// extracted by mini-css-extract-plugin
export default {"animation":"IconSVG_animation__gdhgy","itemAppear":"IconSVG_itemAppear__GkTyA"};